<template>
    <div class="video-body">
        <div class="main-video">
            <video v-if="s" class="video-style" controls :poster="videoList.picture" webkit-playsinline="true"
                   playsinline="true" x5-playsinline="true" :src="videoList.video">
            </video>
            <div class="video-info">
                <div class="video-title">{{ videoList.title }}</div>
                <div class="video-date">
                    <div class="date-front">{{ videoList.writer }}&nbsp;&nbsp;{{ videoList.create_time }}</div>
                    <div class="video-hot">
                        <svg class="icon videoHotIcon" aria-hidden="true">
                            <use xlink:href="#icon-redu"></use>
                        </svg>
                        <div>{{ videoList.hot }}</div>
                    </div>
                </div>
                <div class="video-detail">{{ videoList.description }}</div>
            </div>
            <div class="video-line"></div>
        </div>
        <div class="new-video">
            <div class="new-title">最新视频</div>
            <div class="new-video-content" v-for="(item, i) in newVideoList">
                <router-link :to="{
              name:'Video',
              params:{
                id:item.id
              }
            }" @click.native="x">
                    <div class="newVideo-img-wrapper">
                        <img :src=item.picture alt="">
                    </div>
                    <div class="newVideo-info">
                        <div class="newVideo-title">{{ item.title }}</div>
                        <div class="newVideo-date">{{item.create_time}}</div>
                    </div>
                </router-link>
                <div class="video-line"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import shareTips from './shareTips'
    import $ from 'jquery'

    export default {
        name: "Video",
        data() {
            return {
                s: true,
                fakerPoster: true,
                faker: false,
                videoShow: false,
                videoList: [],
                newVideoList: [],
                showDialog: false,
                dialogOption: {
                    // title: '映派提示',
                    text: ''
                }
            }
        },
        components: {
            shareTips
        },
        watch: {
            '$route': 'getVideoData'
        },
        metaInfo() {
            return {
                title: this.videoList.title || '',
                meta: [{
                    name: 'keywords',
                    content: this.videoList.keywords || ''
                }, {
                    name: 'description',
                    content: this.videoList.description || ''
                }]
            }
        },
        methods: {
            x() {
                this.s = false
                // this.s = true
                this.$nextTick(() => (this.s = true))
            },
            initVideo() {
                let id = this.newVideoList.id || 0
                let myPlayer = this.$video('myVideo' + id, {
                    //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                    controls: true,
                    poster: this.videoList.picture || ''
                });
            },
            poster() {
                $('video').trigger('play');
                this.fakerPoster = false
                this.videoShow = true
            },
            clickShare() {
                this.fakerPoster = true
                this.showDialog = true
                this.videoShow = false
                $('video').trigger('pause');
                this.initAlert()
            },
            getVideoData() {
                var videoApi = `https://api.yopoo.cn/api/v1/minutenew?id=${this.$route.params.id}`;
                this.$http.get(videoApi).then(res => {
                        this.videoList = res.data.data
                    },
                    err => {
                        console.log(err)
                    }
                )
            },
            getNewVideoData() {
                var newApi = `https://api.yopoo.cn/api/v1/recommend`
                this.$http.get(newApi, {
                    params: {
                        id: 1,
                        sort: 'create_time'
                    }
                }).then(res => {
                        this.newVideoList = res.data.data
                    },
                    err => {
                        console.log(err)
                    }
                )
            },

            initAlert() {
                this.showDialog = true;
                this.$refs.Alert.confirm().then(() => {
                    this.showDialog = false;
                }).catch(() => {
                    this.showDialog = false;
                    this.videoShow = true
                    this.fakerPoster = false

                })
            },
        },
        created() {
            this.getVideoData()
            this.getNewVideoData()
            // this.s =  true
            // this.initVideo()
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .video-body {
        background: rgba(255, 255, 255, 1);
        padding-bottom: 1rem;
    }

    .video-line {
        height: 1px;
        background: #E5E5E5;
        margin: 0 .4rem;
    }

    .video-style {
        width: 100vw;
        height: 4.22rem;
        object-fit: fill;
    }

    .video-info {
        display: flex;
        flex-direction: column;
        /*justify-content: center;*/
        /*align-items: center;*/
        margin: .2rem .4rem;
    }

    .video-title {
        font-size: .32rem;
        font-weight: 400;
    }

    .video-date {
        width: 100%;
        font-size: .2rem;
        color: #999;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: .1rem 0;

    }

    .date-front {

    }

    .video-hot {
        display: flex;
        align-items: center;
    }

    .videoHotIcon {
        color: #666;
        width: .3rem;
    }

    .video-detail {
        font-size: .2rem;
        color: #666;
    }

    .new-video {
        margin-top: .4rem;
    }

    .new-title {
        font-size: .32rem;
        margin-left: .4rem;

    }

    .new-video-content > a {
        display: flex;
        width: inherit;
        margin: .2rem .4rem;
    }

    .newVideo-img-wrapper {
        width: 2.8rem;
        height: 1.52rem;
    }

    .newVideo-img-wrapper > img {
        width: 100%;
        height: 100%;
    }

    .newVideo-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-left: .2rem;

    }

    .newVideo-title {
        font-size: .24rem;
    }

    .newVideo-date {
        color: #999;
        font-size: .2rem;
        margin-top: .5rem;
    }

</style>



// WEBPACK FOOTER //
// src/components/Video.vue